module.exports = __webpack_public_path__ + "img/qcode_test.1e057d77.png";